import { gql } from 'apollo-boost';
import { useQuery, QueryResult } from 'react-apollo';
import { removeConnectionsMemoized } from '..';

const queryAllReportBeneficiaries = gql`
  query {
    allReportBeneficiaries {
      edges {
        node {
          dbId
          name
        }
      }
    }
  }
`;

export const useAllReportBeneficiariesFromReportWizard = () => {
  const {
    data: rawData,
    refetch,
    loading,
  } = useQuery(queryAllReportBeneficiaries, { fetchPolicy: 'cache-first' });
  const data =
    rawData?.allReportBeneficiaries?.edges.length > 0
      ? removeConnectionsMemoized(rawData?.allReportBeneficiaries)
      : [];
  return { data, refetch, loading };
};
